export default "__VITE_ASSET__CeESgL7t__"